import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { GeographyService } from "../../shared/core/services/geography.service";
import {AuthApiService} from "./shared/core-jpats/services/auth.service";
import {UserManagementService} from "./shared/core-jpats/services/user-management.service";
import {Subscription} from "rxjs";
import {AccessService} from "./system-management/shared/service/access.service";
import {RoleConstants} from "./system-management/shared/core/role.constants";
import {ButtonChangeLocationComponent} from "./components/button-change-location/button-change-location.component";

import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit{
  authSubscription: Subscription;
  authorized: boolean  = false;
  authInProg: boolean =false;
  trainingMode: boolean = false;
  routerLink:string = '/';
  currentLocationText:string;
  locationChangedSub: Subscription;
  title = 'JPATS';

  constructor(
    geographyService: GeographyService,
    private authApiService: AuthApiService,
    private userManagementService: UserManagementService,
    public accessService: AccessService,
    public roleConstants: RoleConstants,
    private modalService: BsModalService,
    @Inject('SITE_MODE') public siteMode: string,
    @Inject('APP_PATH') public appPath: string,
    @Inject('PROGRAM') public program: string,
    private router: Router,
   ) {
    this.trainingMode = siteMode === 'train';
    this.routerLink = this.routerLink + appPath;
    this.locationChangedSub = this.userManagementService.locationChanged.subscribe((data)=>{
      console.log("location changed");
      UserManagementService.currentData = null;
      this.authorized =true;
      this.authInProg = false;
      this.setupUserHeader();
    });
    this.authSubscription = this.authApiService.authenticate().subscribe((res)=>{
      console.log("auth status", res);
      this.authorized =res.model.user.accountStatus === "1";
      this.authInProg = false;
      this.setupUserHeader();
      if(this.authorized){
        this.authApiService.showLocationSelect.emit(res);
        this.showPopup();
      }
    });
  }
  traningWrapper(){
    return this.trainingMode ? "training-wrapper" : "";
  }
  logout($event){
    this.authApiService.logout();
    return false;
  }
  login(){
    this.authApiService.login();
    return false;
  }
  ngOnInit(): void {
    if(this.userManagementService.getUserSession()){
      this.userManagementService.getCurrentCachedUser().subscribe((res)=>{
        console.log("account status", res);
        this.authorized =res.accountStatus === "1";
        this.authInProg = false;
        this.setupUserHeader();
      });
    }
  }
  showPopup(){
    let buttonChangeLocationComponent = new ButtonChangeLocationComponent(this.authApiService, this.modalService, this.router);
    buttonChangeLocationComponent.showModal(true);
  }
  setupUserHeader(){
    this.userManagementService.getCurrentCachedUser().subscribe((userData)=>{
      if(!userData || !userData.location || !userData.operation){
        this.currentLocationText = 'Location not selected';
        return ;
      }
      this.currentLocationText = `Currently Logged into:  ${userData.location!.description} for ${userData.operation!.description}`;
    });
  }
  ngOnDestroy() {
    this.locationChangedSub.unsubscribe();
    this.authSubscription.unsubscribe();
  }

  toastOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  }
}
